(function () {
    'use strict';

    angular
        .module('app')
        .controller('EquipmentController', EquipmentController);

    EquipmentController.$inject = [
        '$scope',
        '$rootScope',
        '$timeout',
        '$filter',
        'blockUI',
        '$uibModal',
        '$routeParams',
        'SelectService',
        'LoyaltyService',
        'EquipmentService',
        'NotifyService',
        'TerminalService',
        '$location',
        'ShortenerService'
    ];

    function EquipmentController(
        $scope,
        $rootScope,
        $timeout,
        $filter,
        blockUI,
        $uibModal,
        $routeParams,
        SelectService,
        LoyaltyService,
        EquipmentService,
        NotifyService,
        TerminalService,
        $location,
        ShortenerService
    ) {
        $scope.getFiltersList = SelectService.getLPList;
        $scope.data = {
            controller: {
                active: 1,
                communication_settings: {
                    remote_host: '',
                    remote_port: null,
                },
                connection_lost_notification_emails: [],
                connection_lost_notification_frequency: 0,
                notify_if_connection_lost_more_then: 0,
                terminal_id: null,
                title: '',
                type: '',
            },
            notify_if_connection_lost_more_then_options: [
                {id: 0, title: 'Do not notify'},
                {id: 5, title: '5 minutes'},
                {id: 10, title: '10 minutes'},
                {id: 20, title: '20 minutes'},
                {id: 30, title: '30 minutes'},
                {id: 45, title: '45 minutes'},
                {id: 60, title: '1 hour'}
            ],
            connection_lost_notification_frequency_options: [
                {id: 0, title: 'Once'},
                {id: 2, title: '2 hours'},
                {id: 6, title: '6 hours'},
                {id: 12, title: '12 hours'},
                {id: 24, title: '24 hours'},
                {id: 36, title: '36 hours'},
                {id: 48, title: '48 hours'}
            ],
            controller_type_options: [
                {
                    title: 'plc-modicon-m241',
                    id: 'plc-modicon-m241'
                }
            ],
            terminals: $rootScope.TERMINALS,
            controllers: [],
            equipments: [],
            only_active_equipments: false
        };

        $scope.currentTab = 'general';
        $scope.modals = {};

        var block_controllers_list = blockUI.instances.get('controllers_list');
        var block_equipment_list = blockUI.instances.get('equipment_list');


        $scope.isPageMode = isPageMode;
        initController();

        function initController() {
            initPageMode();
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        function initPageMode() {
            $scope._pageMode = 'show';
            TerminalService.All(function (success, data) {
                $scope.data.terminals = $rootScope.TERMINALS;
            })

            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('controller_id')) ? 'edit' : 'show';
                var controller_id = $routeParams.controller_id;
                var loyalty_id = $rootScope.ENV.filters.global_filter.loyalty_id;
                EquipmentService.GetController(loyalty_id, controller_id, function (success, data) {
                    if (success) {
                        $scope.data.controller = data;
                    }
                })
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }
            console.log($scope._pageMode)
        }

        $scope.onChangeTab = function (tab) {
            if ($scope.currentTab === tab) {
                return;
            }
            $scope.currentTab = tab;
            if ($scope.currentTab === 'equipments') {
                loadControllerEquipments()
            }
        }

        function loadControllerEquipments() {
            block_equipment_list.start();
            var controller_id = $scope.data.controller.id;
            var loyalty_id = $scope.data.controller.loyalty_id;
            EquipmentService.GetControllerEquipments(loyalty_id, controller_id, {
                only_active: !$scope.data.only_active_equipments
            }, function (success, data) {
                if (success) {
                    $scope.data.equipments = data;
                }
                block_equipment_list.stop();
            })
        }

        $scope.loadControllerEquipments = loadControllerEquipments;

        function showControllers() {
            block_controllers_list.start();
            var loyalty_id = $scope.data.currentFilter.id;

            if ($scope.data.currentFilter.filter_list_type == "pos") {
                loyalty_id = $scope.data.currentFilter.loyalty_id;
            }
            EquipmentService.GetControllers(loyalty_id, {}, function (success, data) {
                block_controllers_list.stop();
                if (success) {
                    $scope.data.controllers = data;
                }
            })
        }

        function isPageMode(mode) {
            return mode === $scope._pageMode;
        }

        $scope.onCreateController = function (form, closeOnSubmit) {
            if (form.$invalid) {
                form.$dirty = true
            }

            if (form.$valid && form.$dirty) {
                block_controllers_list.start();
                var loyalty_id = $scope.data.terminals.find(function (element) {
                    return element.id === $scope.data.controller.terminal_id
                }).loyalty_id

                var post_data = cleanRequestData($scope.data.controller);
                EquipmentService.CreateController(loyalty_id, post_data, function (success, data) {
                    block_controllers_list.stop();
                    if (!success) {
                        NotifyService.Error(data.message, false);
                    }
                    if (success) {
                        $location.path(`/equipment/edit/${data.id}`);
                        NotifyService.Success('', false);
                    }
                })


            } else {
                form.$dirty = true;
                form.remote_host.$dirty = true;
                form.remote_port.$dirty = true;
                form.terminal_id.$dirty = true;
                form.type.$dirty = true;
            }
        }

        $scope.onEditController = function (form, closeOnSubmit) {
            console.log(form, $scope.data.terminals)
            if (form.$invalid) {
                form.$dirty = true
            }

            if (form.$valid && form.$dirty) {
                block_controllers_list.start();
                var controller_id = $scope.data.controller.id;
                var loyalty_id = $scope.data.controller.loyalty_id;
                var post_data = cleanRequestData($scope.data.controller);
                EquipmentService.ChangeController(loyalty_id, controller_id, post_data, function (success, data) {
                    block_controllers_list.stop();
                    if (!success) {
                        NotifyService.Error(data.message, false);
                    }
                    if (success) {
                        NotifyService.Success('', false);
                    }
                })
            } else {
                form.$dirty = true;
                form.remote_host.$dirty = true;
                form.remote_port.$dirty = true;
                form.terminal_id.$dirty = true;
                form.type.$dirty = true;
            }

        }

        $scope.onCancelCreate = function () {
            $location.path('/equipment');
        }

        $scope.onEquipmentToggleClick = function (equipment) {
            if (equipment.active === 1) {
                equipment.active = 0
            } else {
                equipment.active = 1
            }
            EquipmentService.ChangeControllerEquipment($scope.data.controller.loyalty_id, $scope.data.controller.id, equipment.id, equipment, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    loadControllerEquipments()
                }
            })
        }

        $scope.onControllerToggleClick = function (controller) {
            console.log(controller)
            if (controller.active === 1) {
                controller.active = 0
            } else {
                controller.active = 1
            }
            EquipmentService.ChangeController(controller.loyalty_id, controller.id, controller, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    showControllers()
                }
            })
        }

        $scope.addEquipment = function () {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/pages/equipment/modals/equipment.create.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        active: 1,
                        title: '',
                        monitor_working_status: null,
                        input_number: null,
                        output_number: null,
                        type: 'car-wash',

                    }

                    popup.types = [
                        {
                            id: 'car-wash',
                            title: 'Car wash'
                        }
                    ]

                    popup.onCreate = function (form) {
                        if (form.$invalid) {
                            form.$dirty = true
                        }

                        if (form.$valid && form.$dirty) {
                            var controller_id = $scope.data.controller.id;
                            var loyalty_id = $scope.data.controller.loyalty_id;
                            var post_data = cleanRequestData(popup.data);
                            EquipmentService.CreateControllerEquipment(loyalty_id, controller_id, post_data, function (success, data) {
                                if (success) {
                                    NotifyService.Success('', false);
                                    loadControllerEquipments()
                                    $uibModalInstance.close();
                                }

                                if (!success) {
                                    NotifyService.Error(data.message, false);
                                }
                            })
                        } else {
                            form.$dirty = true;
                            form.title.$dirty = true;
                        }

                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.editEquipment = function (equipment) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/pages/equipment/modals/equipment.edit.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        active: equipment.active,
                        title: equipment.title,
                        monitor_working_status: equipment.monitor_working_status,
                        input_number: equipment.input_number,
                        output_number: equipment.output_number,
                        type: equipment.type,
                    }

                    popup.types = [
                        {
                            id: 'car-wash',
                            title: 'Car wash'
                        }
                    ]

                    popup.onEdit = function (form) {
                        if (form.$invalid) {
                            form.$dirty = true
                        }

                        if (form.$valid && form.$dirty) {
                            var controller_id = $scope.data.controller.id;
                            var loyalty_id = $scope.data.controller.loyalty_id;
                            var post_data = cleanRequestData(popup.data)
                            EquipmentService.ChangeControllerEquipment(loyalty_id, controller_id, equipment.id, post_data, function (success, data) {
                                if (success) {
                                    NotifyService.Success('', false);
                                    loadControllerEquipments()
                                    $uibModalInstance.close();
                                }

                                if (!success) {
                                    NotifyService.Error(data.message, false);
                                }
                            })
                        } else {
                            form.$dirty = true;
                            form.title.$dirty = true;
                        }
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }


        $scope.onShowQR = function (equipment) {
            $scope.modals.EquipmentLink = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.register.link.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        link: ''
                    };

                    var link = `https://${appConfig.platformParams.client_site[$rootScope.LANG]}/equipments`

                    if(equipment) {
                        popup.model.link = equipment.short_url;
                    }

                    if (!equipment) {
                        ShortenerService.Create(link, function (success, response) {
                            if (!success) {
                                popup.model.link = popup.link;
                                return;
                            }
                            popup.model.link = response.url;
                        });
                    }

                    popup.onPrint = function () {
                        var printContents = document.getElementById('printable-qr').innerHTML,
                            canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                            canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                            popupWin = window.open('', '_blank',
                                'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

                        printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

                        popupWin.document.open();
                        popupWin.document.write('<html><head><base href="/"><title></title>' +
                            '<link href="assets/print/print_qr.min.css" rel="stylesheet"/></head>' +
                            '<body>' + printContents + '</body></html>');
                        popupWin.focus();
                        // setTimeout(function () {
                        //     popupWin.document.execCommand('print');
                        //     popupWin.print();
                        //     popupWin.document.close();
                        //     popupWin.close();
                        // }, 10);
                        var count = popupWin.document.querySelectorAll('img, link').length;

                        function printOnLoad() {
                            setTimeout(function () {
                                popupWin.focus();
                                popupWin.document.execCommand('print');
                                // popupWin.print();
                                popupWin.document.close();
                                popupWin.close();
                            }, 200);
                        }

                        if (count) {
                            popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                el.onload = function () {
                                    if (!--count) {
                                        printOnLoad();
                                    }
                                };
                            });
                        } else {
                            printOnLoad();
                        }
                    };

                    popup.onCopyLink = function () {
                        $scope.modals.EquipmentLink.close();
                    };

                    popup.onCancelClick = function () {
                        $scope.modals.EquipmentLink.close();
                    };
                }
            });
        };

        $rootScope.$watch("LP_LIST", function (newValue, oldValue) {

            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.LP_LIST);
                if (
                    $rootScope.ENV.filters.global_filter &&
                    $rootScope.ENV.filters.global_filter.loyalty_id !== "0"
                ) {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (
                        filterItem
                    ) {
                        if (filterItem.filter_list_type === "loyalty") {
                            if (
                                filterItem.id ===
                                $rootScope.ENV.filters.global_filter.loyalty_id
                            ) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === "pos") {
                            if (
                                filterItem.loyalty_id ===
                                $rootScope.ENV.filters.global_filter.loyalty_id
                            ) {
                                return true;
                            }
                        }
                    });
                } else {
                    $scope.data.currentFilter = getFirstActive($scope.data.filtersList);
                }
            }
        });

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {
            if (newValue) {
                var l = $rootScope.ENV.filters.transactions_list;
                if (l)
                    l.filter = newValue;
                else
                    l = {filter: newValue};

                if (l.filter.filter_list_type === 'loyalty') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.id};
                } else if (l.filter.filter_list_type === 'pos' || l.filter.filter_list_type === 'register') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.loyalty_id};
                } else if (l.filter.id === '0') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: '0'};
                }

                $rootScope.ENV.filters.transactions_list = l;
                $rootScope.storeENV();
                showControllers()
            }
        }, true);

    }
})();
